import dotProp from "dot-prop";
import invoiceItemSchema from 'forms/invoiceItemSchema'
import ContactForm from "../components/contacts/ContactForm";
import OrganisationForm from "../components/organisations/OrganisationForm";
import { actions } from "../react-redux-form";
import { getInvoiceConfigurations } from "../selectors/invoice_configurations";

const invoiceSchema = function(state, props) {
  let creditNote = props.creditNote
  let configs = getInvoiceConfigurations(state)
  const receiverType = dotProp.get(state, `entities.invoice.byId.${props.entityId}.receiverType`)
  const showAnonymize = !creditNote && receiverType === 'Organisation'

  let onSelectDossier = (dossierId) => {
    return function(dispatch) {
      const contactId = dotProp.get(state, `entities.dossier.byId.${dossierId}.patientId`)
      dispatch(actions.change(`entities.invoice.byId.${props.entityId}.receiverId`, contactId))
      dispatch(actions.change(`entities.invoice.byId.${props.entityId}.receiverType`, 'Contact'))
      dispatch(actions.change(`entities.invoice.byId.${props.entityId}.anonymized`, false))
    }
  }

  const uiSchema = {
    "ui:order": [  "dossierId", "receiverId", "anonymized", "senderConfigId",  "invoiceDate", "paid" , "*"],
    "ui:readonly": props.readonly,
    "invoiceDate": {
      "ui:options": {
        "width": 4
      }
    },
    "paid": {
      "ui:widget": creditNote ? "hidden" : undefined
    },
    "creditNoteReferenceInvoiceId":{
      "ui:widget": "hidden"
    },
    "creditNoteReason":{
      "ui:widget": creditNote ? undefined : "hidden"
    },
    "proposed": {
      "ui:widget": "hidden",
    },
    "concept": {
      "ui:widget": "hidden",
    },
    "responsibleId": {
      "ui:widget": "hidden",
    },
    "receiverType": {
      "ui:widget": "hidden",
    },
    "dossierId": {
      "ui:widget": props.forProposedInvoice || creditNote ? "hidden" : null,
      "ui:group": 'receiver',
      "ui:field": "PaginatedSelectorField",
      "ui:options": {
        "width": 4,
        "entityName": "dossier",
        "displayAttribute": (dossier) => `${dossier.patient && dossier.patient.firstName} ${dossier.patient && dossier.patient.lastName}`,
        "onSelect": onSelectDossier,
      }
    },

    "anonymized": {
      "ui:widget": showAnonymize ? undefined : "hidden",
      "ui:options": {
        "width": 4
      }
    },
    "receiverId": {
      "ui:group": 'receiver',
      "ui:widget": creditNote ? "hidden" : null,
      "ui:field": "PolymorphicSelectorField",
      "ui:options": {
        "width": 4,
        "editable": true,
        "addable": true,
        "fetchEntityAfterSelect": true,
        "types": [
          {
            "EntityForm": ContactForm,
            "entityName": "contact",
            "icon": "user",
            "paginated": true,
            "displayAttribute": (contact) => `${contact.firstName} ${contact.lastName}`
          }, {
            "EntityForm": OrganisationForm,
            "entityName": "organisation",
            "icon": "building",
            "displayAttribute": (orga) => `${orga.name}`
          }
        ]
      }
    },
    "senderConfigId": {
      "ui:widget": configs.length < 2 || creditNote ? "hidden" : null,
      "ui:field": "SelectorField",
      "ui:options": {
        "width": 4,
        "entityName": "invoiceConfiguration",
        "displayAttribute": (config) => `${config.name}`,
      }
    },
    "invoiceItems": {
      "ui:title": I18n.t('api.forms.invoice_item.title'),
      "ui:options": {
        "entityName": "invoiceItem",
        "displayTitle": false
      },
      "items" : {
        "ui:field": "NestedFormField",
        "ui:options": {
          "entityName": "invoiceItem",
          "displayTitle": false,
          "inline": true
        },
        "ui:schema": invoiceItemSchema(state, props)
      },
    }
  }

  return uiSchema
}

export default invoiceSchema;
